import PMWSliderComponentVO from "./pmwslidervo.js";
import EditorBaseComponentVO from "./editorbasecomponentvo.js";

export default class PMWStepButtons extends EditorBaseComponentVO {
    /**
     * @param {string} property
     * @param {string} propertyLabel
     * @param {string} units
     * @param {number} min
     * @param {number} max
     * @param {object} [opts={}]
     * @param {number|string} [opts.defaults=0]
     * @param {number} [opts.step=1]
     * @param {Component|null} [opts.component=null]
     * @param {boolean} [opts.isResponsive=false]
     */
    constructor(property, propertyLabel, units, min, max, opts={}) {
        opts.defaults = opts.defaults || 0;
        opts.step = opts.step || 1;
        opts.component = opts.component || null;
        opts.isResponsive = opts.isResponsive || false;

        super(property, propertyLabel, units, min, max, opts.defaults, window.PMW.emails.styles.ID_STEP_BUTTONS, false, opts.component, opts.isResponsive);
        this.step = opts.step;
    }

    get step() {
        return this._step;
    }

    set step(val) {
        this._step = val;
    }

    toObject() {
        let obj = super.toObject();
        obj.step = this.step;

        return obj;
    }
}
